import React, { useState, useRef, useEffect } from 'react';
import {
  Grid,
  Typography,
  Tooltip,
  Button,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/system';
import Confetti from 'react-confetti';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { variants } from '../../../variants/variants';
import UserAvatar from '../../../common/UserAvatar';

const ShabashWinnerCard = ({ winner, setSelectedWinner, setOpen }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [hovered, setHovered] = useState(false);
  const [cardSize, setCardSize] = useState({ width: 0, height: 0 });
  const cardRef = useRef(null);

  const handleOverviewClick = () => {
    setSelectedWinner(winner);
    setOpen(true);
  };

  useEffect(() => {
    if (cardRef.current) {
      const { offsetWidth, offsetHeight } = cardRef.current;
      setCardSize({ width: offsetWidth, height: offsetHeight });
    }
  }, [hovered, isSm]);

  return (
    <Grid item xs={12} sm={12} md={6} lg={3} xl={3} p={0.5}>
      <Grid
        ref={cardRef}
        sx={{
          wrap: 'nowrap',
          height: isSm ? '25vh' : '32vh',
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          boxShadow: 'none',
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          borderRadius: '8px',
          textAlign: 'center',
          transition: 'all 0.1s ease-in-out',
          '&:hover': {
            transform: 'scale(1.0)',
            boxShadow: variants.BOX_SHADOW,
          },
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {hovered && (
          <Confetti
            numberOfPieces={200}
            width={cardSize.width}
            height={cardSize.height}
            recycle={true}
          />
        )}

        <Tooltip title="Overview">
          <Button
            onClick={handleOverviewClick}
            sx={{
              position: 'absolute',
              top: theme.spacing(1),
              right: theme.spacing(1),
              zIndex: 1,
            }}
          >
            <InfoOutlinedIcon />
          </Button>
        </Tooltip>

        <UserAvatar
          src={winner?.nomineePhoto}
          sx={{ width: 80, height: 80, mb: 2 }}
        />

        <Typography
          variant="h6"
          sx={{
            mb: isSm ? 0 : 1,
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            [theme.breakpoints.down('sm')]: {
              fontSize: '1rem',
            },
          }}
        >
          {winner?.name}
        </Typography>

        {!isSm && (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{
              mb: 1,
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
              },
            }}
          >
            {winner?.department}
          </Typography>
        )}

        <Typography
          variant="subtitle1"
          color="text.secondary"
          sx={{
            mb: isSm ? 0 : 1,
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            [theme.breakpoints.down('sm')]: {
              fontSize: '0.8rem',
            },
          }}
        >
          {winner?.designation}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ShabashWinnerCard;
